import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import { MessageSquarePlus, AlertTriangle } from "lucide-react";
import { Button } from "@shadcn-in-nx/ui/button";
import { useBluelagoon } from "@bluelagoon";
import { useAuth } from "../../context/AuthContext";

export default function LongThreadNudge({ onStartNewChat }) {
    const { t } = useTranslation();
    const { getUser } = useAuth();
    const { call: markTutorialComplete } = useBluelagoon({
        method: "markTutorialComplete",
    });

    const handleDismiss = async () => {
        await markTutorialComplete({ tutorialKey: "long_thread_tip" });
        await getUser();
    };

    return (
        <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            className="bg-amber-50 border border-amber-200 rounded-lg p-3 mx-auto max-w-md"
        >
            <div className="flex items-start gap-2">
                <AlertTriangle className="h-4 w-4 text-amber-500 mt-0.5 flex-shrink-0" />
                <div className="flex-1 min-w-0">
                    <p className="text-sm text-amber-800 mb-2">
                        {t("chatMessages.longThreadTip")}
                    </p>
                    <div className="flex gap-2">
                        <Button size="sm" variant="default" className="h-7 text-xs bg-amber-600 hover:bg-amber-700" onClick={onStartNewChat}>
                            <MessageSquarePlus className="h-3 w-3 mr-1" />
                            {t("chatMessages.startNewChat")}
                        </Button>
                        <Button size="sm" variant="ghost" className="h-7 text-xs text-amber-700 hover:bg-amber-100" onClick={handleDismiss}>
                            {t("chatMessages.longThreadDismiss")}
                        </Button>
                    </div>
                </div>
            </div>
        </motion.div>
    );
}
